/** Spec §14.2 page 9: parent notifications with acknowledge actions. */
import { useAckAlert, useAlerts } from "../api/hooks.js";
import { StateBadge } from "../components/StateBadge.js";
import { PageState } from "../components/PageState.js";

export function AlertsPage() {
  const alerts = useAlerts();
  const ack = useAckAlert();

  return (
    <PageState query={{ isPending: alerts.isPending, error: alerts.error }}>
      {(alerts.data ?? []).length === 0 ? (
        <p className="notice">No open alerts.</p>
      ) : (
        <table>
          <thead><tr><th>Severity</th><th>Event</th><th>Action</th></tr></thead>
          <tbody>
            {(alerts.data ?? []).map((a) => (
              <tr key={a.id}>
                <td><StateBadge state={a.severity} /></td>
                <td>{a.event_type}</td>
                <td><button disabled={ack.isPending} onClick={() => ack.mutate(a.id)}>Acknowledge</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </PageState>
  );
}
